import type { TElement } from '@udecode/plate';
import { useEditorPlugin, useEditorSelector, usePluginOption } from '@udecode/plate/react';
import { useCallback } from 'react';

import type { FigureKind } from '../../lib';
import { FigureCaptionPlugin } from '../FigureCaptionPlugin';

export const useFigureCaptionForElement = (element: TElement) => {
    const plugin = useEditorPlugin(FigureCaptionPlugin);
    const captionPosition = usePluginOption(FigureCaptionPlugin, 'captionPosition');
    const hasCaption = useEditorSelector(e => (
        e.getPlugin(FigureCaptionPlugin).api.figureCaption.isAbove(element) ||
        e.getPlugin(FigureCaptionPlugin).api.figureCaption.isBelow(element)
    ), [ element ]);

    const insertCaption = useCallback((kind: FigureKind) => {
        plugin.tf.insert.figureCaption(element, kind, captionPosition[kind] ?? 'below');
    }, [element, plugin, captionPosition]);

    const removeCaption = useCallback(() => {
        plugin.tf.remove.figureCaption(element);
    }, [element, plugin]);

    return {
        hasCaption,
        insertCaption,
        removeCaption,
    };
};
